import React, { useEffect, useRef, useState } from 'react';
import { ButtonWrapper, InfoBox, Subheading, TextWrapper, Wrapper } from './Style';
import {
  CHEVRON_LEFT_ICON,
  DOCUMENT_ID_ICON_DUAL_TONE,
  CLOSE_POPUP_ICON,
  INFO_NEW_ICON
} from '@Images';
import { CommonButton, StepHeader, ModalFactory } from '@Components';
import {
  ERROR_DOC_EXPIRED_MESSAGE,
  PASSPORT_FORM,
  UPLOAD_DOCUMENT_SCREEN,
  defaultFileSize,
  screenSettings,
  totalSteps
} from '../../utils/constants';
import { NF_SCREENS } from '../../root/screenConstants';
import PassportUploadComponent from './passport';
import DocumentUploadComponent from './documentsuploadComponent';
import { ParentContainer } from '../../styles';
import CancelPaymentModal from '../../utils/cancel-payment-modal';
import { activateLoader, disableLoader, scrollToTop } from '@Redux/actions/ui-trigger';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import {
  changeNiumForexScreen,
  getNiumForexDocumentsUploadList,
  getNiumForexUserDetails,
  submitNiumForexDocumentsUploadList
} from '@Redux/actions/nium-forex';
import {
  FLOW_TYPE_TRANSACTION,
  NF_NEWFEMA,
  NF_NEWFEMA_CT,
  NF_PASSPORT_UPLOAD,
  NF_PASSPORT_UPLOAD_CT,
  NF_REPEATFEMA,
  NF_REPEATFEMA_CT,
  NF_UPLOADDOCS,
  NF_UPLOADDOCS_CT
} from '@Utils/constants/eventsConstants';
import { IDocumentData, UploadDocumentScreenProps } from '../../utils/interface';
import moment from 'moment';
import { IStore } from '../../../../store.type';
import { NIUM_FOREX_FILE_SIZE_LIMIT } from '../../../../redux/action-contants';
import { FilesErrorTypes } from '../../../user-flow/individual/revampedUserFlow/Interfaces/interface';
import { getFlagValue, isFlagEnabled } from '../../../../redux/actions/flagsmith/flagsmith-main';
import { logEvent } from '../../../../utils/events/logUserEvents';
import { LOG_TYPE } from '../../../../utils/events/eventsConstants';

type IDocData = {
  identity_number?: number;
  date_of_issue?: string;
  date_of_expiry?: string;
  code: string;
  fieldname: string;
  issuing_country?: string;
  is_back_document?: boolean;
};
type IData = {
  temp_transaction_id: number;
  type?: string;
  documents?: string;
  use_existing_documents: boolean;
};

const UploadDocumentScreen = (props: UploadDocumentScreenProps): React.ReactElement => {
  const {
    changeNiumForexScreen,
    submitNiumForexDocumentsUploadList,
    getAllformVal,
    activateLoader,
    disableLoader,
    transactionDetails,
    dispatch,
    scrollToTop,
    isNiumForexUser
  } = props;
  const stepperData = screenSettings[NF_SCREENS.upload_documents as keyof typeof screenSettings];
  const fileSizeLimit =
    (isFlagEnabled(NIUM_FOREX_FILE_SIZE_LIMIT) && getFlagValue(NIUM_FOREX_FILE_SIZE_LIMIT)) ||
    defaultFileSize;

  const [documentList, setDocumentList] = useState<IDocumentData[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [files, setFiles] = useState<FileList | null>();
  const [fileErrorFlag, setFileErrorFlag] = useState<boolean>(false);
  const [documentExist, setDocumentExist] = useState(false);
  const [isNiumForexUserFileSizeError, setIsNiumForexUserFileSizeError] = useState<boolean>(false);

  const fileBackUploadInputRef = useRef<HTMLInputElement>(null);
  const fileFrontUploadInputRef = useRef<HTMLInputElement>(null);
  const [frontFilesBase, setFrontFilesBase] = useState<string>('');
  const [backFilesBase, setBackFilesBase] = useState<string>('');
  const [frontFiles, setFrontFiles] = useState<FileList | null>();
  const [backFiles, setBackFiles] = useState<FileList | null>();
  const [fileErrors, setFilesError] = useState<FilesErrorTypes>({
    frontError: '',
    backError: ''
  });

  const renderListOfDocuments = async () => {
    dispatch(activateLoader());
    const response: any = await dispatch(
      getNiumForexDocumentsUploadList(transactionDetails?.tempTransactionId)
    );
    const documentData = response?.data?.data?.document_data;
    if (response) {
      if (response?.data?.all_docs_uploaded) {
        dispatch(getNiumForexUserDetails());
        dispatch(changeNiumForexScreen(NF_SCREENS.aadhar_verification));
      } else {
        setDocumentExist(response?.data?.all_required_docs_exist);
        const passportData = documentData?.find((item: any) =>
          item?.document_code?.toLowerCase()?.includes('passport')
        );
        if (passportData) {
          let sortedDocumentsList = [passportData];
          if (documentData) {
            sortedDocumentsList = [
              ...sortedDocumentsList,
              ...documentData.filter(
                (item: IDocumentData) => item.document_code !== passportData.document_code
              )
            ];
          }
          setDocumentList(sortedDocumentsList);
        } else setDocumentList(documentData);
      }
    }

    dispatch(disableLoader());
  };

  const renderComponent = () => {
    if (documentList?.length > 0 && currentIndex <= documentList?.length) {
      const currentScreenData = documentList[currentIndex - 1];
      if (currentScreenData?.document_code?.toLowerCase()?.includes('passport')) {
        return (
          <PassportUploadComponent
            data={currentScreenData}
            handleDocumentUpload={submit}
            dispatch={dispatch}
            defaultValue={getAllformVal?.issuing_country}
            fileFrontUploadInputRef={fileFrontUploadInputRef}
            fileBackUploadInputRef={fileBackUploadInputRef}
            setFilesError={setFilesError}
            frontFiles={frontFiles}
            backFiles={backFiles}
            frontFilesBase={frontFilesBase}
            backFilesBase={backFilesBase}
            setFrontFiles={setFrontFiles}
            setBackFiles={setBackFiles}
            setFrontFilesBase={setFrontFilesBase}
            setBackFilesBase={setBackFilesBase}
            fileErrors={fileErrors}
            isNiumForexUser={isNiumForexUser}
            fileSizeLimit={fileSizeLimit}
          />
        );
      }
      return (
        <DocumentUploadComponent
          data={currentScreenData}
          files={files}
          setFiles={setFiles}
          fileErrorFlag={fileErrorFlag}
          handleDocumentUpload={submit}
          isNiumForexUserFileSizeError={isNiumForexUserFileSizeError}
        />
      );
    }
  };

  const addEvents = (eventName?: string, cleverTapEvent?: string) => {
    const ctData = {
      pageName: NF_SCREENS.upload_documents
    };
    logEvent(eventName, FLOW_TYPE_TRANSACTION, ctData, LOG_TYPE.CLEVER_TAP);
  };

  const handlePassportDocumentUpload = async (
    data: IData | any,
    eventName: string,
    cleverTapEvent: string,
    sendExistingDocs?: boolean
  ) => {
    const sizeInMB = fileSizeLimit / (1024 * 1024);
    const useExistingDocuments = sendExistingDocs && documentExist;
    if ((!frontFiles || !backFiles) && !useExistingDocuments) {
      setFilesError({
        frontError: !frontFiles ? 'Required' : '',
        backError: !backFiles ? 'Required' : ''
      });
    } else if (frontFiles?.length && fileSizeLimit && frontFiles[0].size > fileSizeLimit) {
      setFilesError((prevError) => ({
        frontError: `File size should not be more than ${sizeInMB}MB`,
        backError: prevError.backError
      }));
    } else if (backFiles?.length && fileSizeLimit && backFiles[0].size > fileSizeLimit) {
      setFilesError((prevError) => ({
        frontError: prevError.frontError,
        backError: `File size should not be more than ${sizeInMB}MB`
      }));
    } else {
      dispatch(activateLoader());
      const response: any = await dispatch(submitNiumForexDocumentsUploadList(data));
      if (response?.data?.success) {
        if (useExistingDocuments) {
          dispatch(changeNiumForexScreen(NF_SCREENS.aadhar_verification));
        } else if (currentIndex < documentList?.length) {
          setFrontFiles(null);
          setBackFiles(null);
          setFilesError({
            frontError: '',
            backError: ''
          });
          setCurrentIndex((prevIndex) => prevIndex + 1);
          dispatch(scrollToTop());
          dispatch(disableLoader());
        } else renderListOfDocuments();
        addEvents(eventName, cleverTapEvent);
      }
      dispatch(disableLoader());
    }
  };

  const handleDocumentUpload = async (
    data: IData,
    eventName: string,
    cleverTapEvent: string,
    sendExistingDocs?: boolean
  ) => {
    const useExistingDocuments = sendExistingDocs && documentExist;
    if (!files?.length && !useExistingDocuments) {
      setFileErrorFlag(true);
    } else if (files?.length && fileSizeLimit && files[0].size > fileSizeLimit) {
      setIsNiumForexUserFileSizeError(true);
    } else {
      dispatch(activateLoader());
      const response: any = await dispatch(submitNiumForexDocumentsUploadList(data));
      if (response?.data?.success) {
        if (useExistingDocuments) {
          dispatch(changeNiumForexScreen(NF_SCREENS.aadhar_verification));
        } else if (currentIndex < documentList?.length) {
          setFiles(null);
          setFileErrorFlag(false);
          setCurrentIndex((prevIndex) => prevIndex + 1);
          dispatch(scrollToTop());
          dispatch(disableLoader());
        } else renderListOfDocuments();
        addEvents(eventName, cleverTapEvent);
      } else {
        if (
          response?.data?.statusCode === 500 &&
          response?.data?.message === ERROR_DOC_EXPIRED_MESSAGE
        ) {
          setDocumentExist(false);
        }
      }
      dispatch(disableLoader());
    }
  };

  const submit = (document_code: string, document_input_type?: string) => {
    const isPassport = document_code?.toLowerCase()?.includes('passport');
    if (isPassport) {
      const { identity_number, date_of_expiry, issuing_country, date_of_issue } = getAllformVal;
      const issueDate = moment(date_of_issue, 'DD/MM/YYYY').format('YYYY-MM-DD');
      const expiryDate = moment(date_of_expiry, 'DD/MM/YYYY').format('YYYY-MM-DD');
      const passportBack = `${document_code?.toLowerCase()}_doc_file_back`;
      const passportFront = `${document_code?.toLowerCase()}_doc`;
      const passportDocumentData = {
        identity_number: identity_number,
        date_of_issue: issueDate,
        date_of_expiry: expiryDate,
        code: document_code,
        issuing_country: issuing_country
      };
      const documentData: IDocData[] = [
        {
          ...passportDocumentData,
          fieldname: passportFront,
          is_back_document: false
        },
        {
          ...passportDocumentData,
          fieldname: passportBack,
          is_back_document: true
        }
      ];
      const passportData = {
        temp_transaction_id: transactionDetails?.tempTransactionId,
        type: document_input_type,
        documents: JSON.stringify(documentData),
        use_existing_documents: false,
        [passportFront]: frontFiles?.[0],
        [passportBack]: backFiles?.[0]
      };
      handlePassportDocumentUpload(passportData, NF_PASSPORT_UPLOAD, NF_PASSPORT_UPLOAD_CT);
    } else {
      const docName = `${document_code?.toLowerCase()}_doc`;
      const otherDocumentData: IDocData[] = [
        {
          code: document_code,
          fieldname: docName
        }
      ];
      const otherDocsData = {
        temp_transaction_id: transactionDetails?.tempTransactionId,
        type: document_input_type,
        documents: JSON.stringify(otherDocumentData),
        use_existing_documents: false,
        [docName]: files?.[0]
      };
      const documentCode = document_code?.toLowerCase();
      handleDocumentUpload(
        otherDocsData,
        `${NF_UPLOADDOCS}_${documentCode}`,
        `nf_UploadDocs_${documentCode}`
      );
    }
  };

  const handleUpload = () => {
    if (documentExist) {
      const data = {
        temp_transaction_id: transactionDetails?.tempTransactionId,
        use_existing_documents: true
      };
      handleDocumentUpload(data, NF_REPEATFEMA, NF_REPEATFEMA_CT, true);
    } else {
      dispatch(scrollToTop());
      setCurrentIndex((prevIndex) => prevIndex + 1);
      addEvents(NF_UPLOADDOCS, NF_UPLOADDOCS_CT);
    }
  };

  const handleUploadNewDocuments = () => {
    dispatch(scrollToTop());
    setCurrentIndex((prevIndex) => prevIndex + 1);
    addEvents(NF_NEWFEMA, NF_NEWFEMA_CT);
  };

  const onCancelPayment = async () => {
    // @ts-ignore
    return await ModalFactory.builder?.(
      (onClose: any) => (
        <CancelPaymentModal
          onContinue={() => onClose(true)}
          postPan={false}
          onConfirm={() => {
            dispatch(changeNiumForexScreen(NF_SCREENS.send_money));
            onClose(true);
          }}
        />
      ),
      'center-modal insta-modal',
      true
    );
  };

  const onBackNavigation = () => {
    dispatch(changeNiumForexScreen(NF_SCREENS.recipient));
  };

  useEffect(() => {
    renderListOfDocuments();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ParentContainer padding={[48, 20]}>
      <div className="navigationContainer">
        {currentIndex < 1 && (
          <img
            className="backButton"
            src={CHEVRON_LEFT_ICON}
            alt="back"
            onClick={onBackNavigation}
          />
        )}
        <img className="closeButton" src={CLOSE_POPUP_ICON} alt="close" onClick={onCancelPayment} />
      </div>
      {currentIndex < 1 ? (
        <>
          <StepHeader
            heading={UPLOAD_DOCUMENT_SCREEN.uploadFemaDocuments.heading}
            headerLogo={DOCUMENT_ID_ICON_DUAL_TONE}
            stepNumber={stepperData?.stepNumber}
            totalSteps={totalSteps}
            subHeading={UPLOAD_DOCUMENT_SCREEN.uploadFemaDocuments.subHeading}
          />
          <Wrapper>
            {documentExist && (
              <InfoBox>
                <img src={INFO_NEW_ICON} alt="" className="image-container" />
                <TextWrapper>{UPLOAD_DOCUMENT_SCREEN.uploadFemaDocuments.warningText}</TextWrapper>
              </InfoBox>
            )}
            <Subheading>
              {UPLOAD_DOCUMENT_SCREEN.uploadFemaDocuments.documentsPendingUpload}
            </Subheading>
            <div className="process-list-container">
              {documentList?.map((item: IDocumentData, index: number) => (
                <ul className="list" key={index}>
                  <li className="list-item">{item?.label}</li>
                </ul>
              ))}
            </div>
          </Wrapper>
          <CommonButton
            text={
              documentExist
                ? UPLOAD_DOCUMENT_SCREEN.uploadFemaDocuments.button1
                : UPLOAD_DOCUMENT_SCREEN.uploadFemaDocuments.heading
            }
            width={450}
            height={46}
            onClick={handleUpload}
          />
          {documentExist && (
            <ButtonWrapper>
              <CommonButton
                text={UPLOAD_DOCUMENT_SCREEN.uploadFemaDocuments.button2}
                width={450}
                height={46}
                onClick={handleUploadNewDocuments}
                type="secondary"
              />
            </ButtonWrapper>
          )}
        </>
      ) : (
        renderComponent()
      )}
    </ParentContainer>
  );
};

function mapStateToProps(reduxState: IStore) {
  const getAllformVal = getFormValues(PASSPORT_FORM)(reduxState);
  const {
    rootReducer: {
      niumForexReducer: { transactionDetails, isNiumForexUser }
    }
  } = reduxState;
  return {
    getAllformVal,
    transactionDetails,
    isNiumForexUser
  };
}

export default connect<any, any, any, IStore>(mapStateToProps, (dispatch: any) => {
  return {
    activateLoader,
    disableLoader,
    changeNiumForexScreen,
    getNiumForexDocumentsUploadList,
    submitNiumForexDocumentsUploadList,
    scrollToTop,
    dispatch
  };
  //@ts-ignore
})(UploadDocumentScreen);
